import { render, staticRenderFns } from "./UserCredentialsForm.vue?vue&type=template&id=121c9458&scoped=true"
import script from "./UserCredentialsForm.vue?vue&type=script&lang=js"
export * from "./UserCredentialsForm.vue?vue&type=script&lang=js"
import style0 from "./UserCredentialsForm.vue?vue&type=style&index=0&id=121c9458&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121c9458",
  null
  
)

export default component.exports